import { SignInScreen } from "@otii/ui/sign-in";
import { useAuthConfig } from "../../lib/queries";

export function SignIn() {
  const { data: cfg, isLoading } = useAuthConfig();
  return (
    <SignInScreen
      product="Hub"
      tagline="Pipeline, customers and prospects"
      cfg={cfg}
      isLoading={isLoading}
      roleLabel={(role) => (role === "admin" ? "Admin" : "Team")}
      demoNotice={{ title: "Otii Hub demo", body: "Fictional providers and customers. Pick who to be below; changes stay in this browser tab and reset when you reload." }}
      noUsersHint="No users yet. Set HUB_ADMIN_EMAILS or SEED_DEMO=true."
    />
  );
}
